import React from "react";
import "../../styles/Tabella.css"

function TabellaOrariPreAgo() {
    return(
        <div className="table-container">
            <table className="table table-bordered m-auto" style={{width: "90%"}}>
                <thead>
                <tr>
                    <th className="header-cell" scope="col">Lun</th>
                    <th className="header-cell" scope="col">Mar</th>
                    <th className="header-cell" scope="col">Mer</th>
                    <th className="header-cell" scope="col">Gio</th>
                    <th className="header-cell" scope="col">Ven</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="data-cell">20:00 - 21:30</td>
                    <td className="data-cell">19:30 - 21:30</td>
                    <td className="data-cell"></td>
                    <td className="data-cell">20:00 - 21:30</td>
                    <td className="data-cell">19:30 - 21:30</td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

export default TabellaOrariPreAgo